import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
  CloseFullscreen,
  Close,
  OpenInNew,
  Toll,
  TrendingUpSharp,
  TrendingDownSharp,
  TrendingFlatSharp,
  LinkOffOutlined,
  LinkRounded,
  Visibility,
  ArrowOutward,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Tooltip as MUITooltip } from "@mui/material";
import { fontSize, styled } from "@mui/system";
// import { TrendingDown, Minus, PieChart, ChevronDown ,X} from 'lucide-react';
import { TypeAnimation } from "react-type-animation";
import bggenai from "../../assets/bggenai.png";
import bgsd from "../../assets/bgsd.png";
import ailoader from "../../assets/ailoader.gif";
import { TbTopologyStar3 } from "react-icons/tb";
// import { PieChart, Pie, Tooltip, Legend } from 'recharts';
import { 
  LineChart, 
  Line, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer ,
  Label,
  ReferenceLine,
  Area,
  AreaChart
} from 'recharts';
import { PieChartComponent } from "./PieChartComponent";
import gs from "../../assets/gs.png";
import { useFileContext } from "./FileContext";
import sourceicon from "../../assets/source.png";
// In each component (InsightContainer, CommodityChart, PorterForces)
import { useAtom } from "jotai";
import { selectedCategoryAtom } from "./atoms"; // adjust path as needed

export const CPOMarketInsights = ({
  categoryNews,
  indiSummaries,
  globalSummaries,
  filteredResults,
}) => {
  const [selectedCategory, setSelectedCategory] = useAtom(selectedCategoryAtom);
  const [showNewsOverlay, setShowNewsOverlay] = useState(false);
  const [showChartDialog, setShowChartDialog] = useState(false);
  const [chartData, setChartData] = useState(null);
  const [chartTitle, setChartTitle] = useState("");

  // ... your other code ...
console.log("global summaries for CPO is:", globalSummaries);
  // Make sure tableData is defined properly
  // The issue is here - we need to properly define tableData
  const tableData = Object.entries(globalSummaries || {}).map(([category, data]) => {
    // The actual structure appears to be:
    // category: { "Focus Level": { "Justification": "...", "Rating": "..." } }
    
    // Check if the category exists in the data and has the proper structure
    if (data && data["Focus Level"]) {
      return {
        category: category,
        outlook: data["Focus Level"]["Justification"] || "No data available",
        focus: data["Focus Level"]["Rating"] || "N/A",
      };
    }
    
    return {
      category: category,
      outlook: "No data available",
      focus: "N/A",
    };
  });

  // Add this function to handle focus chip click
  // Add this function to handle focus chip click
const handleFocusChipClick = (e, category) => {
  e.stopPropagation(); // Prevent triggering the row click
  console.log("category clicked:", category);
  console.log("filteredResults in MI are:", filteredResults);
  // Access the specific category data from filteredResults instead of globalSummaries
  if (filteredResults && filteredResults[category]) {
    // Check for series in the category
    const categoryData = filteredResults[category][category];
    console.log("categoryData for category:", category, categoryData);
    
    if (categoryData && categoryData.series && categoryData.series.length > 0) {
      // Get the first series
      const firstSeries = categoryData.series[0];
      console.log("firstSeries:", firstSeries);
      
      if (firstSeries && firstSeries.series_data) {
        const seriesData = firstSeries.series_data;
        console.log("seriesData for category:", category, seriesData);
        
        // Check if the expected structure exists
        if (seriesData.content && seriesData.content.points) {
          const points = seriesData.content.points;
          
          // Prepare data for the chart
          const processedData = points.map(point => ({
            date: point.date,
            value: point.value
          }));
          
          console.log("processedData for", category, ":", processedData);
          
          setChartData(processedData);
          setChartTitle(firstSeries["Series Name"] || "Price Trends");
          setShowChartDialog(true);
        } else {
          console.error("Unexpected data structure:", seriesData);
          setChartData(null);
        }
      }
    } else {
      console.log("No series data available for category:", category);
      setChartData(null);
    }
  } else {
    console.log("Category not found in filteredResults:", category);
    setChartData(null);
  }
  
  // Always show the dialog, even if there's no data (it will show "No data available")
  setShowChartDialog(true);
};
  const colors = [
    "#FFC107", "#FF5722", "#4CAF50", "#03A9F4", 
    "#E91E63", "#9C27B0", "#673AB7", "#00BCD4", 
    "#8BC34A", "#FF9800"
  ];

  return (
    <Box
    className="pdf-section-CPO"
    sx={{ position: 'relative',marginTop:'18px' }}>
      {/* Header container with flexbox for alignment */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'space-between', 
        marginBottom: '12px'
      }}>
        {/* Left side with icon and title */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <img 
            src={gs} 
            alt="Global Summary" 
            style={{ width: "18px", height: "18px" }} 
          />
          <Typography sx={{
            fontStyle: 'Inter',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '16.94px',
            letterSpacing: '0%',
            color: '#FFFFFF'
          }}>
            Key Highlights of Top Categories
          </Typography>
        </Box>
    
        {/* Read More button positioned on the right */}
        <Button 
          onClick={() => setShowNewsOverlay(true)}
          sx={{
            fontStyle: "Roboto",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "15px",
            color: "#BE3FF5",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            textTransform: "none",
          }}
        >
          View all articles
        </Button>
      </Box>
    
      {/* Table display replacing the summary list */}
      <TableContainer component={Paper} sx={{ 
        maxWidth: '100%', 
        backgroundColor: 'transparent',
        boxShadow: 'none',
        border: "1px solid #FFFFFF0F",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF0F",
      }}>
        <Table size="small" aria-label="category analysis table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ 
                fontStyle: 'Inter', 
                fontWeight: 600, 
                fontSize: '13px', 
                color: '#FFFFFF', 
                borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '8px 16px 8px 8px',
                width: '15%',
                backgroundColor: "#353641B2",
              }}>
                Category
              </TableCell>
              <TableCell sx={{ 
                fontStyle: 'Inter', 
                fontWeight: 600, 
                fontSize: '13px', 
                color: '#FFFFFF', 
                borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '8px 16px',
                width: '60%',
                backgroundColor: "#353641B2",
              }}>
                Outlook
              </TableCell>
              <TableCell sx={{ 
                fontStyle: 'Inter', 
                fontWeight: 600, 
                fontSize: '13px', 
                color: '#FFFFFF', 
                borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '8px 8px 8px 16px',
                width: '10%',
                backgroundColor: "#353641B2",
              }}>
                Focus <MUITooltip
                bg="rgba(255, 255, 255, 0.1)"
    title={
      <div style={{ padding: '8px', maxWidth: '320px' }}>
      <Typography gutterBottom sx={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)', paddingBottom: '4px', marginBottom: '4px' ,fontSize: '12px', fontStyle:'Roboto'}}>
        Focus Categories
      </Typography>
      
      <Typography  paragraph sx={{ marginBottom: '10px', fontSize: '12px' }}>
        <span style={{ 
          display: 'inline-block', 
          width: '8px', 
          height: '8px', 
          backgroundColor: '#FF5252', 
          borderRadius: '50%',
          marginRight: '4px' 
        }}></span>
        <strong style={{color:'white'}}>High Focus:</strong> Critical categories requiring immediate attention due to significant cost impacts, volatility, or supply risks
      </Typography>
      
      <Typography  paragraph sx={{ marginBottom: '10px', fontSize: '12px'  }}>
        <span style={{ 
          display: 'inline-block', 
          width: '8px', 
          height: '8px', 
          backgroundColor: '#FFC107', 
          borderRadius: '50%',
          marginRight: '4px' 
        }}></span>
        <strong style={{color:'white'}}>Medium Focus:</strong> Important categories with moderate cost impact or manageable challenges
      </Typography>
      
      <Typography  sx={{ fontSize: '12px' }}>
        <span style={{ 
          display: 'inline-block', 
          width: '8px', 
          height: '8px', 
          backgroundColor: '#4CAF50', 
          borderRadius: '50%',
          marginRight: '4px' 
        }}></span>
        <strong style={{color:'white'}}>Low Focus:</strong> Categories with minimal cost impact, stable conditions, or limited strategic importance
      </Typography>
    </div>
    }
    arrow
  >
    <Visibility sx={{ fontSize: "12px", color: "#FFFFFF", cursor: "pointer" }} />
  </MUITooltip>
              </TableCell>

              {/* <TableCell sx={{ 
                fontStyle: 'Inter', 
                fontWeight: 600, 
                fontSize: '13px', 
                color: '#FFFFFF', 
                borderBottom: '1px solid rgba(255, 255, 255, 0.2)',
                padding: '8px 16px',
                width: '10%',
                backgroundColor: "#353641B2",
              }}>
                Price Trends
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData.length > 0 ? (
              tableData.map((row, index) => (
                <TableRow 
                  key={index} 
                  sx={{ 
                    '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' },
                    cursor: 'pointer',
                  }}
                  onClick={() => setSelectedCategory(row.category)}
                >
                  <TableCell sx={{ 
                    fontStyle: 'Inter', 
                    fontWeight: 400, 
                    fontSize: '12px', 
                    color: '#FFFFFF', 
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '8px 16px 8px 8px'
                  }}>
                    {row.category}
                  </TableCell>
                  <TableCell sx={{ 
                    fontStyle: 'Inter', 
                    fontWeight: 400, 
                    fontSize: '12px', 
                    color: '#FFFFFFCC', 
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '8px 16px'
                  }}>
                    {row.outlook}
                  </TableCell>
                  <TableCell sx={{ 
                    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                    padding: '8px 8px 8px 16px',
                  }}>
                    <Chip 
                      label={row.focus} 
                      size="small"
                      // onClick={(e) => handleFocusChipClick(e, row.category)}
                      sx={{
                        fontStyle: 'Inter',
                        fontSize: '12px',
                        fontWeight: 400,
                        backgroundColor: row.focus === 'High' ? 'rgba(255, 77, 77, 0.2)' : 
                                         row.focus === 'Medium' ? 'rgba(255, 193, 7, 0.2)' : 
                                         row.focus === 'Low' ? 'rgba(76, 175, 80, 0.2)' : 'rgba(255, 255, 255, 0.1)',
                        color: row.focus === 'High' ? '#FF4D4D' : 
                               row.focus === 'Medium' ? '#FFC107' : 
                               row.focus === 'Low' ? '#4CAF50' : '#FFFFFF',
                        border: '1px solid',
                        borderColor: row.focus === 'High' ? '#FF4D4D' : 
                                    row.focus === 'Medium' ? '#FFC107' : 
                                    row.focus === 'Low' ? '#4CAF50' : 'transparent',
                      }}
                    />
                  </TableCell>
                  {/* <TableCell
  sx={{ 
    fontStyle: 'Inter', 
    fontWeight: 400, 
    fontSize: '12px', 
    color: '#FFFFFFCC', 
    borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '8px 16px',
    cursor: 'pointer'
  }}
  onClick={(e) => handleFocusChipClick(e, row.category)}
>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
    View <ArrowOutward sx={{ fontSize: 16 }} />
  </Box>
</TableCell> */}

                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ color: '#FFFFFFCC' }}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    
      {/* News overlay dialog */}
{/* News overlay dialog */}
<Dialog 
  open={showNewsOverlay} 
  onClose={() => setShowNewsOverlay(false)} 
  maxWidth="md"
  fullWidth
  PaperProps={{
    style: {
      backgroundImage: `url(${bggenai})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "rgba(129, 129, 129)",
      boxShadow: "none",
    },
  }}
>
  <DialogTitle sx={{ color: "white", fontSize: "0.9rem" }}>
    News Articles
    <IconButton
      onClick={() => setShowNewsOverlay(false)}
      sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent
    dividers
    sx={{ borderColor: "rgba(255, 255, 255,0.5)" }}
  >
    {Object.entries(categoryNews || {}).map(([category, articles], mainIndex) => (
      <Box key={mainIndex} sx={{ marginBottom: 3 }}>
        <Typography variant="h6" sx={{ color: "white", mb: 1, fontSize: "16px", fontWeight: 600 }}>
          {category}
        </Typography>
        
        {Array.isArray(articles) ? (
          articles.map((article, articleIndex) => (
            <Card
              key={articleIndex}
              sx={{
                mb: 2,
                display: "flex",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#181921",
                boxShadow: "none",
                border: "1px solid rgba(255, 255, 255)",
                borderRadius: "8px",
              }}
            >
                       <CardMedia
                            component="img"
                            sx={{
                              width: "199px",
                              // height: "152px",
                              borderRadius: "8px 0 0 0",
                            }}
                            image={(() => {
                              const imageUrls = [
                                "https://news.ufl.edu/media/newsufledu/images/2021/12/supply-chain.jpg",
                                "https://cdn.prod.website-files.com/630b302c741fe7a987396dd0/63ac83827a881de06792b095_top-supply-chain-events-p-1080.jpg",
                                "https://www.shipbob.com/wp-content/uploads/2021/06/supply-chain-technology.jpg",
                              ];
                              const randomIndex = Math.floor(
                                Math.random() * imageUrls.length
                              );
                              return imageUrls[randomIndex];
                            })()}
                            alt="News thumbnail"
                          />
              <CardContent
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  color: "white",
                  fontSize: "0.9rem",
                  position: "relative",
                }}
              >
                <IconButton
                  onClick={() => window.open(article.link, "_blank")}
                  sx={{
                    position: "absolute",
                    top: 8,
                    right: 8,
                    color: "white",
                    zIndex: 10,
                    background: "#FFFFFF0",
                  }}
                >
                  <OpenInNew
                    style={{
                      marginRight: "0.3rem",
                      height: "16px",
                      width: "16px",
                    }}
                  />
                </IconButton>

                <Typography
                  gutterBottom
                  sx={{
                    fontStyle: "Roboto",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "16.94px",
                    textAlign: "left",
                    mb: 0.5,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    pr: "40px",
                  }}
                >
                  {article.title}
                </Typography>

                {/* Insights Section */}
                {article.link && indiSummaries[article.link] && (
                  <Box
                    sx={{
                      mt: 1,
                      pt: 1,
                      borderTop: "1px solid rgba(255, 255, 255, 0.2)",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 600,
                        fontStyle: "Roboto",
                        mb: 0.5,
                        color: "rgba(255, 255, 255, 0.8)",
                      }}
                    >
                      <AutoAwesome
                        sx={{ mr: 0.1, width: "16px", height: "16px" }}
                      />
                      Insights
                    </Typography>
                    {Array.isArray(indiSummaries[article.link].summary) && (
                      <ul
                        style={{
                          margin: 0,
                          paddingLeft: "20px",
                          listStyleType: "disc",
                          fontSize: "12px",
                        }}
                      >
                        {indiSummaries[article.link].summary.map(
                          (item, idx) => (
                            <li
                              key={idx}
                              style={{
                                color: "rgba(255, 255, 255, 0.7)",
                                marginBottom: "4px",
                                fontSize: "12px",
                                fontWeight: 400,
                                fontStyle: "Roboto",
                                lineHeight: "16px",
                              }}
                            >
                              {item}
                            </li>
                          )
                        )}
                      </ul>
                    )}
                  </Box>
                )}

                <Box sx={{ mt: 2 }}>
                  <Typography
                    color="rgba(255, 255, 255, 0.7)"
                    sx={{
                      fontStyle: "Roboto",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "16.94px",
                      textAlign: "left",
                      mb: 0.5,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: "rgba(255, 255, 255, 0.7)",
                    }}
                  >
                    {article.source || 'Unknown Source'}
                    <span
                      style={{
                        margin: "0 8px",
                        color: "rgba(255, 255, 255, 0.7)",
                      }}
                    >
                      •
                    </span>
                    {article.date}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          ))
        ) : (
          <Typography sx={{ color: "white" }}>No articles available</Typography>
        )}
      </Box>
    ))}
    
    {Object.keys(categoryNews || {}).length === 0 && (
      <Typography sx={{ color: "white" }}>No news articles available</Typography>
    )}
  </DialogContent>
</Dialog>


<Dialog
  open={showChartDialog}
  onClose={() => setShowChartDialog(false)}
  maxWidth="md"
  fullWidth
  PaperProps={{
    style: {
      backgroundImage: `url(${bggenai})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "#1a1a2e",
      boxShadow: "none",
      border: "1px solid #2C2D3C",
      borderRadius: '8px',
    },
  }}
>
  <DialogTitle sx={{ color: "white", fontSize: "1rem" }}>
    {chartTitle}
    <IconButton
      onClick={() => setShowChartDialog(false)}
      sx={{ position: "absolute", right: 8, top: 8, color: "white" }}
    >
      <CloseIcon />
    </IconButton>
  </DialogTitle>
  <DialogContent dividers sx={{ borderColor: "rgba(255, 255, 255,0.5)", height: "400px", backgroundColor: "#1a1a2e" }}>
  {chartData ? (
    <ResponsiveContainer width="100%" height="100%">
      {(() => {
        // Process data to have only 4 data points (one per month)
        const processedData = (() => {
          // Get unique months from data
          const uniqueMonths = [];
          const monthSet = new Set();
          const monthlyData = [];
          
          // Group data by month and get average value for each month
          chartData.forEach(item => {
            const date = new Date(
              item.date.substring(6, 10), // year
              parseInt(item.date.substring(3, 5)) - 1, // month (0-indexed)
              item.date.substring(0, 2) // day
            );
            const monthYear = `${date.getMonth()}-${date.getFullYear()}`;
            
            if (!monthSet.has(monthYear)) {
              monthSet.add(monthYear);
              
              // Find all data points for this month
              const monthData = chartData.filter(d => {
                const dDate = new Date(
                  d.date.substring(6, 10),
                  parseInt(d.date.substring(3, 5)) - 1,
                  d.date.substring(0, 2)
                );
                const dMonthYear = `${dDate.getMonth()}-${dDate.getFullYear()}`;
                return dMonthYear === monthYear;
              });
              
              // Calculate average value for this month
              const total = monthData.reduce((sum, d) => sum + d.value, 0);
              const avg = total / monthData.length;
              
              // Use the first date from this month
              const year = date.getFullYear().toString().substr(-2); // Get last 2 digits of year
              monthlyData.push({
                date: monthData[0].date,
                value: avg,
                month: date.toLocaleString('default', { month: 'short' }) + '-' + year,
                active: true // Mark all points as active
              });
            }
          });
          
          // Select 4 evenly spaced months
          if (monthlyData.length <= 4) {
            return monthlyData;
          } else {
            const result = [];
            result.push(monthlyData[0]); // First month
            
            const step = Math.floor(monthlyData.length / 3);
            result.push(monthlyData[step]); // One-third point
            result.push(monthlyData[step * 2]); // Two-thirds point
            
            result.push(monthlyData[monthlyData.length - 1]); // Last month
            
            return result;
          }
        })();
        
        return (
          <AreaChart
            data={processedData}
            margin={{
              top: 20,
              right: 30,
              left: 0,
              bottom: 25,
            }}
          >
            <XAxis 
              dataKey="month"
              axisLine={{ stroke: 'rgba(255,255,255,0.15)', strokeWidth: 1 }}
              tick={{ fill: "#FFFFFF", fontSize: 11 }}
              style={{ fontStyle: "Roboto" }}
              padding={{ left: 0, right: 0 }}
            >
              <Label
                value="Time period"
                position="bottom"
                offset={10}
                style={{
                  textAnchor: "middle",
                  fill: "white",
                  fontWeight: 400,
                  fontSize: "12px",
                  fontStyle: "Roboto",
                }}
              />
            </XAxis>
            
            <YAxis 
              axisLine={{ stroke: 'rgba(255,255,255,0.15)', strokeWidth: 1 }}
              tickLine={false}
              tick={{ fill: "#FFFFFF", fontSize: 11 }}
              style={{ fontStyle: "Roboto" }}
              // Use calculated min/max instead of default domain
              domain={[
                dataMin => Math.floor(dataMin * 0.9), // Lower bound: 90% of minimum value, rounded down
                dataMax => Math.ceil(dataMax * 1.1)  // Upper bound: 110% of maximum value, rounded up
              ]}
              tickCount={5}
              // Format large numbers to be more readable
              tickFormatter={(value) => {
                if (value >= 1000000) return `${(value / 1000000).toFixed(1)}M`;
                if (value >= 1000) return `${(value / 1000).toFixed(1)}K`;
                return value;
              }}
            >
              <Label
                value="Price Trend Index"
                angle={-90}
                position="insideLeft"
                style={{
                  fill: "rgba(255,255,255,0.8)",
                  fontSize: "12px",
                  fontStyle: "Roboto",
                  textAnchor: "middle",
                }}
                offset={10}
                dy={10}
              />
            </YAxis>
            
            <Tooltip 
              contentStyle={{
                backgroundColor: "rgba(26, 26, 46, 0.9)",
                color: "#fff",
                fontSize: "12px",
                fontStyle: 'Roboto',
                border: "1px solid rgba(255,255,255,0.2)",
                borderRadius: "4px",
                padding: "8px 12px",
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)"
              }}
              cursor={{ stroke: "rgba(255,255,255,0.2)", strokeWidth: 1, strokeDasharray: "3 3" }}
              formatter={(value, name) => {
                // Format large numbers in tooltip
                if (value >= 1000000) return [`${(value / 1000000).toFixed(2)}M`, "Value"];
                if (value >= 1000) return [`${(value / 1000).toFixed(2)}K`, "Value"];
                return [Number(value.toFixed(2)), "Value"];
              }}
              labelFormatter={(label) => `Date: ${label}`}
            />
            
            <defs>
              <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#b74fff" stopOpacity={0.8} />
                <stop offset="100%" stopColor="#b74fff" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            
            <Area 
              type="natural" 
              dataKey="value" 
              stroke="#b74fff"
              strokeWidth={2}
              fillOpacity={1}
              fill="url(#colorGradient)"
              activeDot={{ 
                r: 6, 
                stroke: "#FFFFFF", 
                strokeWidth: 2,
                fill: "#b74fff"
              }}
              dot={{ // Always show dots for each data point
                r: 6,
                stroke: "#FFFFFF",
                strokeWidth: 2,
                fill: "#b74fff"
              }}
              isAnimationActive={true}
              connectNulls={true}
              stackId="1"
              // Set baseline to 0 to remove the gap from x-axis
              baseValue={0}
            />
          </AreaChart>
        );
      })()}
    </ResponsiveContainer>
  ) : (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100%',
      backgroundColor: "#1a1a2e"
    }}>
      <Typography sx={{ 
        color: 'white', 
        fontStyle: 'Roboto', 
        fontSize: '14px',
        opacity: 0.7
      }}>
        No data available
      </Typography>
    </Box>
  )}
  </DialogContent>
</Dialog>  </Box>
  );
};